import {
  createLootRateDisplayControlController,
} from "../js/loot-rate-display-controls.js";
import {
  browserLootRateDisplayPreferenceRepository,
} from "../js/loot-rate-display-preferences.js";
import {
  parseCalculatorLootRateDisplayMode,
} from "../js/components/calculator-loot-rate-presentation.js";
import { assertMapShellProjectionV1 } from "./map-shell-projection.js";

export function lootRateDisplayModeFromMapProjection(projection) {
  const current = assertMapShellProjectionV1(projection);
  return parseCalculatorLootRateDisplayMode(
    current.ui?.windowUi?.settings?.lootRateDisplayMode ?? "normalized",
    "map loot rate display mode",
  );
}

export function mapLootRateDisplayModeSignalPatch(value) {
  const mode = parseCalculatorLootRateDisplayMode(
    value,
    "map loot rate display preference",
  );
  return {
    _map_ui: {
      windowUi: {
        settings: {
          lootRateDisplayMode: mode,
        },
      },
    },
  };
}

export function createMapLootRateDisplayPreferenceController({
  root,
  readProjection,
  dispatchPatch = () => false,
  repository = null,
  reportError,
  createObserver,
} = {}) {
  if (typeof readProjection !== "function") {
    throw new TypeError(
      "Map loot rate display preference requires a projection reader",
    );
  }
  if (typeof dispatchPatch !== "function") {
    throw new TypeError(
      "Map loot rate display preference requires a signal patch dispatcher",
    );
  }

  const owner = repository ?? browserLootRateDisplayPreferenceRepository();
  const controller = createLootRateDisplayControlController({
    root,
    repository: owner,
    reportError,
    createObserver,
    projectMode(value) {
      const mode = parseCalculatorLootRateDisplayMode(
        value,
        "authoritative loot rate display preference",
      );
      if (lootRateDisplayModeFromMapProjection(readProjection()) === mode) {
        return false;
      }
      if (dispatchPatch(mapLootRateDisplayModeSignalPatch(mode)) === false) {
        throw new Error(
          "Map loot rate display preference projection was rejected",
        );
      }
      return true;
    },
  });

  return Object.freeze({
    start: controller.start,
    stop: controller.stop,
  });
}
